export const serviceNote = ({ theme: { colors } }) => ({
    color: colors.text,
    fontSize: '0.875rem',
    letterSpacing: '0.1px',
    lineHeight: 1.43,
});
